module.exports = __webpack_public_path__ + "static/media/brand-circle.ae9bfa68.svg";